export const locale = {
    lang: "pt-BR",
    data: {
        PRIVACY_POLICE: {
            TITLE: "Política de Privacidade",
            DEFAULT: "Política de Privacidade não definidos.",
            SUBMIT_ERROR: "Erro ao recuperar política de privacidade.",
            BUTTON_LABEL: "Fechar"
        }
    }
};
